import React, { useState, useEffect } from 'react';
import './SortPanel.scss';
import { SORT_OPTIONS } from './sortHelper';

const IMG_BASE_URL = 'https://static.lenskart.com/owndays/img/plp';

const sort = (props, selectedOption) => {
  const { categoryActions, categoryId, location, order } = props;
  const originalHash = window.location.hash;
  const searchParams = new URLSearchParams(originalHash.substring(1));

  let modifiedLocation = '';

  if (location.hash.includes('dir')) {
    let loc = null;
    if (location.hash.split('dir')[0].length > 0) {
      loc = location.hash.slice(
        location.hash.lastIndexOf('dir') - 1,
        location.hash.lastIndexOf('true') + 4
      );
    } else {
      loc = location.hash.slice(
        location.hash.lastIndexOf('dir'),
        location.hash.lastIndexOf('true') + 4
      );
    }
    location.hash.split(loc).forEach(value => {
      modifiedLocation += value;
    });
  } else {
    modifiedLocation = location.hash;
  }

  if (!location.hash.includes('dir') && location.hash.includes('&gan_data=true')) {
    modifiedLocation = modifiedLocation.replace('&gan_data=true', '');
  }

  if (window.dtm?.LenskartRewamp) {
    window.dtm.LenskartRewamp.Listing.sort.applySortingOnProduct(selectedOption);
  }

  const pageParam = searchParams.get('page');

  searchParams.delete('dir');
  searchParams.delete('sort');
  searchParams.delete('gan_data');

  searchParams.set('dir', 'desc');
  searchParams.set('sort', selectedOption);
  searchParams.set('gan_data', 'true');

  if (!modifiedLocation.includes('#') && pageParam !== null) {
    searchParams.set('page', pageParam);
  }

  const tempSearchParams = new URLSearchParams();
  searchParams.forEach((value, key) => {
    if (key !== 'dir' && key !== 'sort' && key !== 'gan_data') {
      tempSearchParams.set(`filter_${key}`, value);
    } else {
      tempSearchParams.set(key, value);
    }
  });

  searchParams.delete('page');
  const tempString = searchParams.toString().replace(/%2C/g, ',');

  if (modifiedLocation.includes('#')) {
    modifiedLocation = modifiedLocation.split('#')[0];
  }
  modifiedLocation += `#${tempString}`;

  const temp = {
    location,
    order: selectedOption,
  };

  const basePath = '/sg/en';
  const fullPath = `${basePath}${location.pathname}`;

  history.pushState('', '', `${fullPath}${modifiedLocation}`);
  temp.location.hash = modifiedLocation;

  window.scrollTo(0, 0);
  categoryActions.modifyData(temp);
  categoryActions.getCategoryData(
    categoryId,
    `#${tempSearchParams.toString().replace(/%2C/g, ',')}`,
    0
  );
};

const SortFilter = props => {
  const { sortFilterValue, dropdownRef, animate } = props;

  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(() => {
    const validSort = SORT_OPTIONS.find(({ name }) => name === sortFilterValue);
    return validSort ? validSort.name : 'popular';
  });

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sortParam = params.get('sort');

    if (sortParam) {
      const validSort = SORT_OPTIONS.find(({ name }) => name === sortParam);
      if (validSort) {
        setSelected(validSort.name);
      }
    }
  }, [window.location.hash]);

  useEffect(() => {
    if (animate) {
      requestAnimationFrame(() => setVisible(true));
    } else {
      setVisible(false);
    }
  }, [animate]);

  if (props.location?.search?.length > 0) {
    return null;
  }

  return (
    <div
      ref={dropdownRef}
      className={`sort-panel ${animate ? 'mount' : ''} ${visible ? 'active' : ''}`}
    >
      <div className="sort-panel__header">
        <div className="sort-panel__header__title">Sort by</div>
        <button
          className="sort-panel__header__close"
          onClick={() => props.toggleSortDropdown(false)}
        >
          <img src={`${IMG_BASE_URL}/close-sp-icon.svg`} alt="Close" />
        </button>
      </div>
      <div className="sort-panel__divider" />
      <ul className="sort-panel__list">
        {SORT_OPTIONS.map(({ name, title }) => (
          <li
            key={name}
            className={`sort-panel__item ${selected === name ? 'active' : ''}`}
            onMouseDown={e => {
              e.preventDefault();
              e.stopPropagation();

              if (selected !== name) {
                setSelected(name);
                props.toggleSortDropdown(false);

                setTimeout(() => {
                  sort(props, name);
                }, 0);
              }
            }}
          >
            <div className={`sort-panel__radio ${selected === name ? 'active' : 'inactive'}`} />
            <span>{title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SortFilter;
